import { useMutation } from '@tanstack/react-query';
import { postUsersInquiryTractor } from '../../../../api/inquiry/mutations/postInquriesTractors';

export const usePostInquiryTractorMutation = () => {
  return useMutation(postUsersInquiryTractor);
};
